import { Outlet } from "react-router";

import classes from "./CenteredPage.module.css";

export const CenteredPage = () => {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Outlet />
      </div>
    </div>
  );
};
